class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.summary = this.mainDetailsToggle.querySelector('summary');
    this.href = this.summary.dataset.href;

    // Ítem padre con destino real (data-href): el clic navega en vez de alternar el details.
    // El hover lo sigue abriendo (global.js) y el foco por teclado lo abre aquí.
    if (this.href) {
      this.summary.addEventListener('click', this.onSummaryClick.bind(this));
      this.summary.addEventListener('auxclick', this.onSummaryAuxClick.bind(this));
      this.summary.addEventListener('focus', this.onSummaryFocus.bind(this));
    }
  }

  onSummaryClick(event) {
    event.preventDefault();

    if (event.metaKey || event.ctrlKey || event.shiftKey) {
      window.open(this.href, '_blank');
      this.summary.setAttribute('aria-expanded', this.mainDetailsToggle.open);
      return;
    }

    window.location.href = this.href;
  }

  onSummaryAuxClick(event) {
    if (event.button !== 1) return;
    event.preventDefault();
    window.open(this.href, '_blank');
  }

  onSummaryFocus(event) {
    // Solo abre con foco por teclado; con mouse el hover ya abre y el clic navega.
    // Si el foco viene de adentro (Escape o Shift+Tab desde el submenú), no reabrir.
    if (!this.summary.matches(':focus-visible')) return;
    if (event.relatedTarget && this.contains(event.relatedTarget)) return;

    this.mainDetailsToggle.open = true;
    this.summary.setAttribute('aria-expanded', true);
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
